import React from 'react';
import { useTheme } from './ThemeContext';
import '../../styles/themeToggle.css';

const ThemeToggle = () => {
  const { theme, toggleTheme } = useTheme();

  return (
    <div className="theme-toggle-container">
      <button 
        className="theme-toggle-button" 
        onClick={toggleTheme} 
        aria-label={`Switch to ${theme === 'dark' ? 'light' : 'dark'} mode`}
      >
        {theme === 'dark' ? (
          <i className="ri-sun-line" title="Switch to light mode"></i>
        ) : (
          <i className="ri-moon-line" title="Switch to dark mode"></i>
        )}
      </button>
    </div>
  );
};

export default ThemeToggle;
